import React from 'react';
import cn from 'classnames';
import { ButtonProps } from '@/ui-components/atoms/Button/Button';
import { LinkProps } from '@/ui-components/atoms/Link/Link';
import { Text } from '@/ui-components/atoms/Text/Text';
import styles from './ctagroup.module.scss';

export interface CTAGroupProps {
    links: React.ReactElement<ButtonProps | LinkProps>[];
    caption?: React.ReactNode;
    desktopAlign?: 'left' | 'center';
    mobileAlign?: 'left' | 'center';
}

export function CTAGroup({
    links = [],
    desktopAlign = 'left',
    mobileAlign = 'center',
    caption = '',
}: CTAGroupProps): React.JSX.Element {
    const ctaGroup = cn(styles.ctaGroup, {
        [styles.desktopCenter]: desktopAlign === 'center',
        [styles.mobileLeft]: mobileAlign === 'left',
    });

    const isTertiary = (el: React.ReactElement<ButtonProps | LinkProps>) =>
        (el.props as ButtonProps)?.variant === 'tertiary';

    const mainLinks = links.filter((el) => !isTertiary(el));
    const tertiaryLinks = links.filter(isTertiary);

    return (
        <div className={ctaGroup} data-cy="cta-group">
            {/* Primary + Secondary grouped */}
            {mainLinks.length > 0 && <div className={styles.mainButtons}>{mainLinks}</div>}

            {/* Caption / legal */}
            {caption && (
                <Text tag="div" variant="text-legal" className={styles.caption}>
                    {caption}
                </Text>
            )}

            {/* Tertiary buttons */}
            {tertiaryLinks.map((el, i) => (
                <div key={`tertiary-${i}`} className={styles.tertiary}>
                    {el}
                </div>
            ))}
        </div>
    );
}
